import { Form, Input } from 'antd'
import { FC } from 'react'
import { authStore } from '../store/auth'
import { useLocation, useNavigate } from 'react-router-dom'
import { RNWelcome } from '../helpers/routeNames'
import { AxiosError } from 'axios'

const Login: FC = () => {
	const { login } = authStore()

	const navigate = useNavigate()
	const location = useLocation()

	const loginFirstDivStyle: React.CSSProperties = {
		width: '100%',
		height: '100vh',
		display: 'flex',
		flexDirection: 'column',
		boxSizing: 'border-box',
		justifyContent: 'center',
		backgroundColor: '#2D4056'
	}

	const loginSecondDivStyle: React.CSSProperties = {
		width: '100%',
		display: 'flex',
		flexDirection: 'column',
		alignItems: 'center',
		justifyContent: 'center',
		backgroundColor: '#2D4056',
		flex: 0,
		padding: 16,
		boxSizing: 'border-box'
	}
	const loginHeaderStyle: React.CSSProperties = {
		color: '#fff',
		fontSize: '30px',
		marginBottom: 0,
		marginTop: 0,
		fontFamily: "'MuseoModerno', 'SFProDisplay', sans-serif",
		fontWeight: 400,
		textAlign: 'center'
	}

	const loginButtonStyle: React.CSSProperties = {
		width: '350px',
		height: '44px',
		backgroundColor: '#4AC382',
		color: '#FFF',
		fontSize: '15px',
		borderRadius: '4px',
		border: 'none',
		marginBottom: 10
	}

	const loginInputStyle: React.CSSProperties = {
		width: '350px',
		height: '44px',
		borderRadius: '4px',
		marginBottom: 12,
		fontSize: '20px'
	}

	// const loginLogoStyle: React.CSSProperties = {
	// 	width: '67px',
	// 	height: '78px'
	// }

	const loginFirmnameStyle: React.CSSProperties = {
		fontFamily: 'MuseoModerno',
		color: '#fff',
		fontSize: '38px',
		margin: '16px 0 0',
		lineHeight: '38px',
		textAlign: 'center'
	}

	const loginFirmDescStyle: React.CSSProperties = {
		fontFamily: 'SFProDisplay',
		fontWeight: 400,
		fontSize: '23px',
		margin: 0,
		color: '#8797AA',
		letterSpacing: '.4px',
		lineHeight: '23px',
		marginTop: 10
	}

	const loginCountryStyle: React.CSSProperties = {
		fontFamily: 'MuseoModerno',
		fontSize: '24px',
		margin: '40px 0 0 0',
		color: '#fff',
		lineHeight: '40px',
		textAlign: 'center'
	}

	const onFinish = async (values: any) => {
		try {
			await login(values.username, values.password)

			navigate(
				decodeURIComponent(
					location.search.replace('?path=', '')
				) || RNWelcome
			)
		} catch (err: any) {
			if (err instanceof AxiosError) {
				alert(err.response?.data.message)
			} else {
				console.log(err)
			}
		}
	}

	return (
		<div style={loginFirstDivStyle}>
			<Form
				style={{
					...loginSecondDivStyle,
					backgroundColor: '#2D4056',
					paddingTop: 0
				}}
				onFinish={onFinish}
				// initialValues={{
				// 	username: 'test@zarafshon.org',
				// 	password: '123456'
				// }}
				layout="vertical">
				<h1 style={loginHeaderStyle}>Login</h1>
				<Form.Item
					name="username"
					label={
						<div
							style={{
								color: '#fff'
							}}>
							Login
						</div>
					}
					style={{ marginBottom: 0 }}>
					<Input style={loginInputStyle} autoFocus />
				</Form.Item>
				<Form.Item
					name="password"
					label={
						<div
							style={{
								color: '#fff'
							}}>
							Пароль
						</div>
					}
					style={{ marginBottom: 0, color: '#fff' }}>
					<Input
						type="password"
						style={{
							...loginInputStyle,
							fontSize: '36px'
						}}
					/>
				</Form.Item>
				<Form.Item
					style={{
						display: 'flex',
						marginBottom: 0
					}}>
					<button style={loginButtonStyle} type="submit">
						Login
					</button>
				</Form.Item>
			</Form>
			<div
				style={{
					...loginSecondDivStyle,
					order: -1,
					justifyContent: 'center'
				}}>
				{/* <Logo style={loginLogoStyle} /> */}

				<img src="/logo.png" alt="Logo" width={67} />
				<h2 style={loginFirmnameStyle}>
					O'zbekiston Temir yo'llari
					{/* <span style={{ color: '#ACDC54' }}>on</span> */}
				</h2>
				<h4 style={loginFirmDescStyle}>Online monitoring</h4>

				<h3 style={loginCountryStyle}>Uzbekistan</h3>
			</div>
		</div>
	)
}

export default Login
